import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetchData } from '../fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AcornProduct = {
  __typename?: 'AcornProduct';
  AdminImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackorderLimit?: Maybe<Scalars['Int']['output']>;
  BotanicalName?: Maybe<Scalars['String']['output']>;
  Characteristics?: Maybe<Scalars['String']['output']>;
  CollectionProductCount?: Maybe<Scalars['Int']['output']>;
  CollectionProducts?: Maybe<Array<Maybe<CollectionProduct>>>;
  CommonName?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DescriptionPlugtrays?: Maybe<Scalars['String']['output']>;
  DisplayMVG?: Maybe<Scalars['Boolean']['output']>;
  DisplayPlugtrays?: Maybe<Scalars['Boolean']['output']>;
  FlowerColor?: Maybe<Scalars['String']['output']>;
  Genus?: Maybe<Scalars['String']['output']>;
  Hardiness?: Maybe<Scalars['String']['output']>;
  Height?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  ImageHashes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  InStock: Scalars['Int']['output'];
  InStockPlugtrays: Scalars['Int']['output'];
  MVGPath?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  NamePlugtrays?: Maybe<Scalars['String']['output']>;
  Price: Scalars['Float']['output'];
  PricePlugtrays: Scalars['Float']['output'];
  QuickbooksId?: Maybe<Scalars['String']['output']>;
  QuickbooksIdPlugtrays?: Maybe<Scalars['String']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TagsPlugtrays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Type: ProductType;
  Uses?: Maybe<Scalars['String']['output']>;
};

export type AcornProductInput = {
  BackorderLimit: Scalars['Int']['input'];
  BotanicalName?: InputMaybe<Scalars['String']['input']>;
  Characteristics?: InputMaybe<Scalars['String']['input']>;
  CollectionProductCount?: InputMaybe<Scalars['Int']['input']>;
  CommonName?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DescriptionPlugtrays?: InputMaybe<Scalars['String']['input']>;
  DisplayMVG: Scalars['Boolean']['input'];
  DisplayPlugtrays: Scalars['Boolean']['input'];
  FlowerColor?: InputMaybe<Scalars['String']['input']>;
  Genus?: InputMaybe<Scalars['String']['input']>;
  Hardiness?: InputMaybe<Scalars['String']['input']>;
  Height?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['ID']['input'];
  Images: Array<InputMaybe<Scalars['String']['input']>>;
  InStock: Scalars['Int']['input'];
  InStockPlugtrays: Scalars['Int']['input'];
  MVGPath?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  NamePlugtrays: Scalars['String']['input'];
  Price: Scalars['Float']['input'];
  PricePlugtrays: Scalars['Float']['input'];
  Slug: Scalars['String']['input'];
  Tags: Array<InputMaybe<Scalars['String']['input']>>;
  TagsPlugtrays: Array<InputMaybe<Scalars['String']['input']>>;
  Type?: InputMaybe<ProductType>;
  Uses?: InputMaybe<Scalars['String']['input']>;
};

export type AcornProducts = {
  __typename?: 'AcornProducts';
  products?: Maybe<Array<Maybe<AcornProduct>>>;
};

export type Address = {
  __typename?: 'Address';
  Address: Scalars['String']['output'];
  Address2?: Maybe<Scalars['String']['output']>;
  City: Scalars['String']['output'];
  State: Scalars['String']['output'];
  Zip: Scalars['String']['output'];
};

export type AddressInput = {
  Address: Scalars['String']['input'];
  Address2?: InputMaybe<Scalars['String']['input']>;
  City: Scalars['String']['input'];
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  State: Scalars['String']['input'];
  Zip: Scalars['String']['input'];
};

export type AdminCreatedGiftCard = {
  __typename?: 'AdminCreatedGiftCard';
  Amount: Scalars['Float']['output'];
  Id: Scalars['ID']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  RecipientEmail: Scalars['String']['output'];
  RecipientName: Scalars['String']['output'];
  SenderName: Scalars['String']['output'];
  Status: Scalars['String']['output'];
  TimestampCreated: Scalars['Float']['output'];
};

export type AdminGiftCard = {
  __typename?: 'AdminGiftCard';
  Amount: Scalars['Float']['output'];
  Balance: Scalars['Float']['output'];
  Id: Scalars['ID']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  OrderGiftCardIndex: Scalars['Int']['output'];
  OrderId: Scalars['String']['output'];
  Pin?: Maybe<Scalars['String']['output']>;
  RecipientEmail: Scalars['String']['output'];
  RecipientName: Scalars['String']['output'];
  SenderName: Scalars['String']['output'];
  Status: Scalars['String']['output'];
  Storefront: Storefront;
  TimestampCreated: Scalars['Int']['output'];
  TimestampUpdated?: Maybe<Scalars['Int']['output']>;
  Transactions: Array<Maybe<GiftCardTransaction>>;
};

export type AllTags = {
  __typename?: 'AllTags';
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  TagsPlugtrays?: Maybe<Array<Scalars['String']['output']>>;
};

export type BackorderProduct = {
  __typename?: 'BackorderProduct';
  Backorders: Array<BackorderWeek>;
  Id: Scalars['String']['output'];
};

export type BackorderWeek = {
  __typename?: 'BackorderWeek';
  Quantity: Scalars['Int']['output'];
  YearWeek: Scalars['String']['output'];
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  Address: Scalars['String']['output'];
  Address2?: Maybe<Scalars['String']['output']>;
  City: Scalars['String']['output'];
  Company?: Maybe<Scalars['String']['output']>;
  Email: Scalars['String']['output'];
  FirstName: Scalars['String']['output'];
  LastName: Scalars['String']['output'];
  Phone: Scalars['String']['output'];
  State: Scalars['String']['output'];
  Zip: Scalars['String']['output'];
};

export type BillingAddressInput = {
  Address: Scalars['String']['input'];
  Address2?: InputMaybe<Scalars['String']['input']>;
  City: Scalars['String']['input'];
  Company?: InputMaybe<Scalars['String']['input']>;
  Email: Scalars['String']['input'];
  FirstName: Scalars['String']['input'];
  LastName: Scalars['String']['input'];
  Phone: Scalars['String']['input'];
  State: Scalars['String']['input'];
  Zip: Scalars['String']['input'];
};

export type Cart = {
  __typename?: 'Cart';
  Billing?: Maybe<BillingAddress>;
  CreateAccount?: Maybe<CreateAccount>;
  GiftCardRedemptions?: Maybe<Array<Maybe<GiftCardRedemption>>>;
  GiftCards?: Maybe<Array<Maybe<GiftCard>>>;
  Payment?: Maybe<Payment>;
  Products?: Maybe<Array<Maybe<CartProduct>>>;
  Shipping?: Maybe<ShippingAddress>;
  ShippingService?: Maybe<Shipping>;
  WaiveWarranty?: Maybe<Scalars['Boolean']['output']>;
  WaiveWarrantyPlugtrays?: Maybe<Scalars['Boolean']['output']>;
};

export type CartProduct = {
  __typename?: 'CartProduct';
  BotanicalName?: Maybe<Scalars['String']['output']>;
  CommonName?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  ImageHashes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LineSubtotal?: Maybe<Scalars['Float']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NamePlugtrays?: Maybe<Scalars['String']['output']>;
  PlantType?: Maybe<PlantType>;
  PlugtrayCount?: Maybe<Scalars['Int']['output']>;
  PotCount?: Maybe<Scalars['Int']['output']>;
  Price?: Maybe<Scalars['Float']['output']>;
  PricePlugtrays?: Maybe<Scalars['Float']['output']>;
  Quantity: Scalars['Int']['output'];
  QuantityBackorder?: Maybe<Scalars['Int']['output']>;
  QuantityValidated?: Maybe<Scalars['Int']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type CartProductInput = {
  Id: Scalars['String']['input'];
  Quantity: Scalars['Int']['input'];
};

export type CdnImage = {
  __typename?: 'CdnImage';
  Hash: Scalars['String']['output'];
  HashedSlug: Scalars['String']['output'];
  Path: Scalars['ID']['output'];
};

export type CheckoutResult = {
  __typename?: 'CheckoutResult';
  BoxSpaceRemainingPots: Scalars['Int']['output'];
  Cart?: Maybe<Cart>;
  Errors: Array<Scalars['String']['output']>;
  GiftCardBalanceAvailable: Scalars['Float']['output'];
  GiftCardRedemptionsTotal: Scalars['Float']['output'];
  GiftCardSubtotal: Scalars['Float']['output'];
  MeetsMinimums: Scalars['Boolean']['output'];
  /** @deprecated Never used */
  Message?: Maybe<Scalars['String']['output']>;
  OrderId?: Maybe<Scalars['String']['output']>;
  PaymentRequired: Scalars['Boolean']['output'];
  PlugtrayCount: Scalars['Int']['output'];
  PotCount: Scalars['Int']['output'];
  Review: Scalars['Boolean']['output'];
  Status: Scalars['String']['output'];
  Storefront: Storefront;
  Subtotal: Scalars['Float']['output'];
  Tax: Scalars['Float']['output'];
  Total: Scalars['Float']['output'];
  TotalToCharge: Scalars['Float']['output'];
  WaiveWarranty?: Maybe<Scalars['Boolean']['output']>;
  WaiveWarrantyPlugtrays?: Maybe<Scalars['Boolean']['output']>;
  WarrantyValid?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectionProduct = {
  __typename?: 'CollectionProduct';
  Id: Scalars['String']['output'];
  PlantType: Scalars['String']['output'];
  Quantity: Scalars['Int']['output'];
};

export type CreateAccount = {
  __typename?: 'CreateAccount';
  Password?: Maybe<Scalars['String']['output']>;
};

export type CreateAccountInput = {
  Password?: InputMaybe<Scalars['String']['input']>;
};

export type GetShippingAddressInput = {
  Address?: InputMaybe<Scalars['String']['input']>;
  Address2?: InputMaybe<Scalars['String']['input']>;
  City?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  State?: InputMaybe<Scalars['String']['input']>;
  Zip: Scalars['String']['input'];
};

export type GiftCard = {
  __typename?: 'GiftCard';
  Amount: Scalars['Int']['output'];
  Id?: Maybe<Scalars['ID']['output']>;
  Index: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  RecipientEmail: Scalars['String']['output'];
  RecipientName: Scalars['String']['output'];
  SenderName: Scalars['String']['output'];
};

export type GiftCardInput = {
  Amount: Scalars['Int']['input'];
  Message?: InputMaybe<Scalars['String']['input']>;
  RecipientEmail: Scalars['String']['input'];
  RecipientName: Scalars['String']['input'];
  SenderName: Scalars['String']['input'];
};

export type GiftCardRedemption = {
  __typename?: 'GiftCardRedemption';
  Balance?: Maybe<Scalars['Float']['output']>;
  Id: Scalars['String']['output'];
};

export type GiftCardRedemptionInput = {
  Id: Scalars['String']['input'];
  Pin: Scalars['String']['input'];
};

export enum GiftCardStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type GiftCardTransaction = {
  __typename?: 'GiftCardTransaction';
  Amount: Scalars['Float']['output'];
  OrderId: Scalars['String']['output'];
  Timestamp: Scalars['Int']['output'];
};

export type GiftCardsPage = {
  __typename?: 'GiftCardsPage';
  Count: Scalars['Int']['output'];
  GiftCards: Array<Maybe<AdminGiftCard>>;
  LastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  ScannedCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AddCartGiftCard?: Maybe<Cart>;
  CheckoutV1?: Maybe<CheckoutResult>;
  ConnectQuickbooksOAuth?: Maybe<Scalars['Boolean']['output']>;
  CreateProductNotificationV1?: Maybe<Scalars['Boolean']['output']>;
  CreateShipmentForOrder: UpsShipment;
  CreateShipmentForOrders: Array<UpsShipment>;
  DeleteProduct?: Maybe<Scalars['Boolean']['output']>;
  IssueNewGiftCard: AdminCreatedGiftCard;
  LoginMergeIdentity?: Maybe<Scalars['Boolean']['output']>;
  RedeemGiftCard?: Maybe<Cart>;
  RemoveCartGiftCard?: Maybe<Cart>;
  RemoveGiftCardToRedeem?: Maybe<Cart>;
  SaveCart?: Maybe<Cart>;
  SaveCartProduct?: Maybe<Cart>;
  SaveEmail?: Maybe<Scalars['Boolean']['output']>;
  SaveOrderAdminMessage: Order;
  SaveOrderStatus?: Maybe<Scalars['Boolean']['output']>;
  SaveProduct: AcornProduct;
  SaveProductBackorderLimit?: Maybe<AcornProduct>;
  SaveProductBulkTags?: Maybe<Scalars['Boolean']['output']>;
  SaveProductInStock?: Maybe<AcornProduct>;
  SaveProductPlugtraysPrice?: Maybe<AcornProduct>;
  SaveProductPlugtraysStock?: Maybe<AcornProduct>;
  SaveProductPrice?: Maybe<AcornProduct>;
  SaveProductStock?: Maybe<AcornProduct>;
  SaveSiteSettings: SiteSettings;
  SaveWarrantyStatesV1?: Maybe<WarrantyStates>;
  ScheduleOrders: Scalars['Boolean']['output'];
  UpdateCartGiftCard?: Maybe<Cart>;
  ValidateAddressV1?: Maybe<Array<Maybe<Address>>>;
  VoidShipment: UpsShipment;
  saveUser?: Maybe<User>;
};


export type MutationAddCartGiftCardArgs = {
  GiftCard: GiftCardInput;
};


export type MutationCheckoutV1Args = {
  Review: Scalars['Boolean']['input'];
  ShippingFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  Storefront?: InputMaybe<Storefront>;
};


export type MutationConnectQuickbooksOAuthArgs = {
  Code: Scalars['String']['input'];
  RedirectUri: Scalars['String']['input'];
};


export type MutationCreateProductNotificationV1Args = {
  Email: Scalars['String']['input'];
  Id: Scalars['String']['input'];
  PlantType: PlantType;
};


export type MutationCreateShipmentForOrderArgs = {
  AddressOverride?: InputMaybe<ShippingAddressInput>;
  OrderId: Scalars['String']['input'];
  Type: ShipmentRequestType;
};


export type MutationCreateShipmentForOrdersArgs = {
  OrderIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteProductArgs = {
  Id: Scalars['ID']['input'];
};


export type MutationIssueNewGiftCardArgs = {
  GiftCard: GiftCardInput;
};


export type MutationLoginMergeIdentityArgs = {
  UserId: Scalars['ID']['input'];
};


export type MutationRedeemGiftCardArgs = {
  Id: Scalars['String']['input'];
  Pin: Scalars['String']['input'];
};


export type MutationRemoveCartGiftCardArgs = {
  Index: Scalars['Int']['input'];
};


export type MutationRemoveGiftCardToRedeemArgs = {
  Index: Scalars['Int']['input'];
};


export type MutationSaveCartArgs = {
  Billing?: InputMaybe<BillingAddressInput>;
  CreateAccount?: InputMaybe<CreateAccountInput>;
  Payment?: InputMaybe<PaymentInput>;
  Shipping?: InputMaybe<ShippingAddressInput>;
  ShippingService?: InputMaybe<ShippingInput>;
  WaiveWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  WaiveWarrantyPlugtrays?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSaveCartProductArgs = {
  Id: Scalars['String']['input'];
  PlantType: PlantType;
  Quantity: Scalars['Int']['input'];
};


export type MutationSaveEmailArgs = {
  Email: Scalars['String']['input'];
  OptOut: Scalars['Boolean']['input'];
};


export type MutationSaveOrderAdminMessageArgs = {
  AdminMessage: Scalars['String']['input'];
  Id: Scalars['ID']['input'];
};


export type MutationSaveOrderStatusArgs = {
  Orders: Array<OrderStatusInput>;
};


export type MutationSaveProductArgs = {
  product?: InputMaybe<AcornProductInput>;
};


export type MutationSaveProductBackorderLimitArgs = {
  BackorderLimit: Scalars['Int']['input'];
  Id: Scalars['ID']['input'];
};


export type MutationSaveProductBulkTagsArgs = {
  Tag: Scalars['String']['input'];
  TaggedProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  UntaggedProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSaveProductInStockArgs = {
  Id: Scalars['ID']['input'];
  InStock: Scalars['Int']['input'];
};


export type MutationSaveProductPlugtraysPriceArgs = {
  Id: Scalars['ID']['input'];
  PricePlugtrays: Scalars['Float']['input'];
};


export type MutationSaveProductPlugtraysStockArgs = {
  Id: Scalars['String']['input'];
  InStockPlugtrays: Scalars['Int']['input'];
};


export type MutationSaveProductPriceArgs = {
  Id: Scalars['ID']['input'];
  Price: Scalars['Float']['input'];
};


export type MutationSaveProductStockArgs = {
  BackorderLimit: Scalars['Int']['input'];
  CollectionProductCount?: InputMaybe<Scalars['Int']['input']>;
  Id: Scalars['ID']['input'];
  InStock: Scalars['Int']['input'];
};


export type MutationSaveSiteSettingsArgs = {
  SiteSettings: SiteSettingsInput;
};


export type MutationSaveWarrantyStatesV1Args = {
  WaiverRequiredStates: Array<Scalars['String']['input']>;
  WarrantyStates: Array<Scalars['String']['input']>;
};


export type MutationScheduleOrdersArgs = {
  EstimatedShippingDate?: InputMaybe<Scalars['Int']['input']>;
  EstimatedShippingDatePlugtrays?: InputMaybe<Scalars['Int']['input']>;
  OrderIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateCartGiftCardArgs = {
  GiftCard: GiftCardInput;
  Index: Scalars['Int']['input'];
};


export type MutationValidateAddressV1Args = {
  Address: AddressInput;
};


export type MutationVoidShipmentArgs = {
  Id: Scalars['String']['input'];
};


export type MutationSaveUserArgs = {
  user: UserInput;
};

export type Order = {
  __typename?: 'Order';
  AdminMessage?: Maybe<Scalars['String']['output']>;
  Billing?: Maybe<BillingAddress>;
  EstimatedShippingDate?: Maybe<Scalars['Int']['output']>;
  EstimatedShippingDatePlugtrays?: Maybe<Scalars['Int']['output']>;
  GiftCardRedemptions?: Maybe<Array<Maybe<OrderGiftCardRedemption>>>;
  GiftCardRedemptionsTotal?: Maybe<Scalars['Float']['output']>;
  GiftCardSubtotal?: Maybe<Scalars['Float']['output']>;
  GiftCards?: Maybe<Array<Maybe<GiftCard>>>;
  Id: Scalars['ID']['output'];
  IdentityId?: Maybe<Scalars['String']['output']>;
  InvoiceId?: Maybe<Scalars['Int']['output']>;
  Payment?: Maybe<Payment>;
  PaymentAuthorization?: Maybe<PaymentAuthorization>;
  PaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  PlugtrayCount?: Maybe<Scalars['Int']['output']>;
  PotCount?: Maybe<Scalars['Int']['output']>;
  Products?: Maybe<Array<Maybe<CartProduct>>>;
  Shipping?: Maybe<ShippingAddress>;
  ShippingService?: Maybe<Shipping>;
  SourceIp?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<OrderStatus>;
  Storefront?: Maybe<Storefront>;
  Subtotal?: Maybe<Scalars['Float']['output']>;
  Tax?: Maybe<Scalars['Float']['output']>;
  TimestampCreated?: Maybe<Scalars['Int']['output']>;
  TimestampShipped?: Maybe<Scalars['Int']['output']>;
  Total?: Maybe<Scalars['Float']['output']>;
  TotalToCharge?: Maybe<Scalars['Float']['output']>;
  UpsShipmentIds?: Maybe<Array<Scalars['String']['output']>>;
  UserId?: Maybe<Scalars['String']['output']>;
  WaiveWarranty?: Maybe<Scalars['Boolean']['output']>;
  WaiveWarrantyPlugtrays?: Maybe<Scalars['Boolean']['output']>;
  WarrantyValid?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderGiftCardRedemption = {
  __typename?: 'OrderGiftCardRedemption';
  Balance: Scalars['Float']['output'];
  Id: Scalars['String']['output'];
};

export enum OrderStatus {
  Approved = 'APPROVED',
  AssignId = 'ASSIGN_ID',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Downloaded = 'DOWNLOADED',
  EmailSent = 'EMAIL_SENT',
  Fulfillment = 'FULFILLMENT',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  PaymentRejected = 'PAYMENT_REJECTED',
  Ready = 'READY',
  Scheduled = 'SCHEDULED',
  Shipped = 'SHIPPED',
  StockAdjusted = 'STOCK_ADJUSTED',
  UserCreated = 'USER_CREATED'
}

export type OrderStatusInput = {
  Id: Scalars['String']['input'];
  Status: OrderStatus;
};

export type OrdersPage = {
  __typename?: 'OrdersPage';
  Count: Scalars['Int']['output'];
  LastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  Orders: Array<Maybe<Order>>;
  ScannedCount: Scalars['Int']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  Token?: Maybe<Scalars['String']['output']>;
};

export type PaymentAuthorization = {
  __typename?: 'PaymentAuthorization';
  ResponseCode?: Maybe<Scalars['String']['output']>;
};

export type PaymentInput = {
  Token: Scalars['String']['input'];
};

export enum PlantType {
  Collection = 'COLLECTION',
  Plugtray = 'PLUGTRAY',
  Pot = 'POT'
}

export type ProductNotification = {
  __typename?: 'ProductNotification';
  ProductId?: Maybe<Scalars['String']['output']>;
  UserCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProductType {
  Collection = 'COLLECTION',
  Plant = 'PLANT'
}

export type Query = {
  __typename?: 'Query';
  CheckoutV1Review?: Maybe<CheckoutResult>;
  GetAcornProduct?: Maybe<AcornProduct>;
  GetAllTags?: Maybe<AllTags>;
  GetBackorderReport: Array<BackorderProduct>;
  GetCart?: Maybe<Cart>;
  GetCdnImages?: Maybe<Array<Maybe<CdnImage>>>;
  GetGiftCard: AdminGiftCard;
  GetGiftCardBalance?: Maybe<UserGiftCard>;
  GetGiftCardsPage?: Maybe<GiftCardsPage>;
  GetMyOrders?: Maybe<Array<Maybe<Order>>>;
  GetOrder?: Maybe<Order>;
  GetOrdersPage?: Maybe<OrdersPage>;
  GetProductNotificationsV1: Array<Maybe<ProductNotification>>;
  GetProducts?: Maybe<AcornProducts>;
  GetProductsWithTag?: Maybe<AcornProducts>;
  GetProductsWithTagPlugtrays?: Maybe<AcornProducts>;
  GetQuickbooksAccounts: Array<Maybe<QuickbooksAccount>>;
  GetQuickbooksAccountsOfSubType: Array<Maybe<QuickbooksAccount>>;
  GetQuickbooksGiftCardProducts: Array<Maybe<QuickbooksProduct>>;
  GetQuickbooksStatus: QuickbooksStatus;
  GetShipments: Array<Maybe<UpsShipment>>;
  GetShipmentsForOrder: Array<Maybe<UpsShipment>>;
  GetShippingOptions?: Maybe<Array<Maybe<ShippingOption>>>;
  GetSiteSettings: SiteSettings;
  GetWarrantyStatesV1: WarrantyStates;
  /** @deprecated Use mutation `ValidateAddressV1`. */
  ValidateAddress?: Maybe<Array<Maybe<Address>>>;
  getUser?: Maybe<User>;
};


export type QueryCheckoutV1ReviewArgs = {
  ShippingFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  Storefront?: InputMaybe<Storefront>;
};


export type QueryGetAcornProductArgs = {
  Id: Scalars['String']['input'];
};


export type QueryGetGiftCardArgs = {
  Id: Scalars['String']['input'];
};


export type QueryGetGiftCardBalanceArgs = {
  Id: Scalars['String']['input'];
  Pin: Scalars['String']['input'];
};


export type QueryGetGiftCardsPageArgs = {
  ExclusiveStartKey?: InputMaybe<Scalars['String']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
  ScanIndexForward?: InputMaybe<Scalars['Boolean']['input']>;
  Status: GiftCardStatus;
};


export type QueryGetOrderArgs = {
  Id: Scalars['String']['input'];
};


export type QueryGetOrdersPageArgs = {
  ExclusiveStartKey?: InputMaybe<Scalars['String']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
  ScanIndexForward?: InputMaybe<Scalars['Boolean']['input']>;
  Status: OrderStatus;
};


export type QueryGetProductNotificationsV1Args = {
  Storefront: Storefront;
};


export type QueryGetProductsWithTagArgs = {
  Tag: Scalars['String']['input'];
};


export type QueryGetProductsWithTagPlugtraysArgs = {
  Tag: Scalars['String']['input'];
};


export type QueryGetQuickbooksAccountsOfSubTypeArgs = {
  AccountSubType: Scalars['String']['input'];
};


export type QueryGetShipmentsArgs = {
  Ids: Array<Scalars['String']['input']>;
};


export type QueryGetShipmentsForOrderArgs = {
  Id: Scalars['String']['input'];
};


export type QueryGetShippingOptionsArgs = {
  Address: GetShippingAddressInput;
  PlugtrayCount: Scalars['Int']['input'];
  PotCount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateAddressArgs = {
  Address: AddressInput;
};

export type QuickbooksAccount = {
  __typename?: 'QuickbooksAccount';
  AccountSubType?: Maybe<Scalars['String']['output']>;
  AccountType?: Maybe<Scalars['String']['output']>;
  Active?: Maybe<Scalars['Boolean']['output']>;
  Classification?: Maybe<Scalars['String']['output']>;
  CurrentBalance?: Maybe<Scalars['Float']['output']>;
  CurrentBalanceWithSubAccounts?: Maybe<Scalars['Float']['output']>;
  FullyQualifiedName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  SubAccount?: Maybe<Scalars['Boolean']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
};

export type QuickbooksCompanyAddress = {
  __typename?: 'QuickbooksCompanyAddress';
  City?: Maybe<Scalars['String']['output']>;
  CountrySubDivisionCode?: Maybe<Scalars['String']['output']>;
  Line1?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
};

export type QuickbooksCompanyInfo = {
  __typename?: 'QuickbooksCompanyInfo';
  CompanyAddr?: Maybe<QuickbooksCompanyAddress>;
  CompanyName?: Maybe<Scalars['String']['output']>;
  LegalName?: Maybe<Scalars['String']['output']>;
};

export type QuickbooksProduct = {
  __typename?: 'QuickbooksProduct';
  Active: Scalars['Boolean']['output'];
  FullyQualifiedName: Scalars['String']['output'];
  Id: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Sku: Scalars['String']['output'];
  Type: Scalars['String']['output'];
};

export type QuickbooksStatus = {
  __typename?: 'QuickbooksStatus';
  CompanyInfo?: Maybe<QuickbooksCompanyInfo>;
  SettingsOk?: Maybe<Scalars['Boolean']['output']>;
};

export enum ShipmentRequestType {
  All = 'ALL',
  None = 'NONE',
  Plugtrays = 'PLUGTRAYS',
  Pots = 'POTS'
}

export enum ShipmentStatus {
  Created = 'CREATED',
  Error = 'ERROR',
  Recorded = 'RECORDED',
  Requested = 'REQUESTED',
  Void = 'VOID'
}

export type Shipping = {
  __typename?: 'Shipping';
  DeliveryInstructions?: Maybe<Scalars['String']['output']>;
  GiftMessage?: Maybe<Scalars['String']['output']>;
  IsGift?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use top level `WaiveWarrantyPlugtrays`. */
  WaiveWarranty?: Maybe<Scalars['Boolean']['output']>;
  shippingService?: Maybe<ShippingService>;
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  Address?: Maybe<Scalars['String']['output']>;
  Address2?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Scalars['String']['output']>;
  DeliveryInstructions?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Zip?: Maybe<Scalars['String']['output']>;
};

export type ShippingAddressInput = {
  Address: Scalars['String']['input'];
  Address2?: InputMaybe<Scalars['String']['input']>;
  City: Scalars['String']['input'];
  Company?: InputMaybe<Scalars['String']['input']>;
  DeliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  Email: Scalars['String']['input'];
  FirstName: Scalars['String']['input'];
  LastName: Scalars['String']['input'];
  Phone: Scalars['String']['input'];
  State: Scalars['String']['input'];
  Zip: Scalars['String']['input'];
};

export type ShippingInput = {
  DeliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  GiftMessage?: InputMaybe<Scalars['String']['input']>;
  IsGift?: InputMaybe<Scalars['Boolean']['input']>;
  WaiveWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  shippingService: ShippingServiceInput;
};

export type ShippingOption = {
  __typename?: 'ShippingOption';
  BillingWeight?: Maybe<Scalars['Float']['output']>;
  DaysInTransit?: Maybe<Scalars['String']['output']>;
  DeliveryTime?: Maybe<Scalars['String']['output']>;
  Price?: Maybe<Scalars['Float']['output']>;
  PriceCurrency?: Maybe<Scalars['String']['output']>;
  ServiceCode?: Maybe<Scalars['String']['output']>;
};

export type ShippingService = {
  __typename?: 'ShippingService';
  BillingWeight?: Maybe<Scalars['Float']['output']>;
  DaysInTransit?: Maybe<Scalars['String']['output']>;
  DeliveryTime?: Maybe<Scalars['String']['output']>;
  Price?: Maybe<Scalars['Float']['output']>;
  ServiceCode?: Maybe<Scalars['String']['output']>;
};

export type ShippingServiceInput = {
  DaysInTransit?: InputMaybe<Scalars['String']['input']>;
  DeliveryTime?: InputMaybe<Scalars['String']['input']>;
  Price?: InputMaybe<Scalars['Float']['input']>;
  ServiceCode?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSettings = {
  __typename?: 'SiteSettings';
  HideBackorders: Scalars['Boolean']['output'];
  QuickbooksGiftCardProductId: Scalars['String']['output'];
  QuickbooksProductSalesOfIncomeAccountId: Scalars['String']['output'];
  QuickbooksRefundDepositToAccountId: Scalars['String']['output'];
};

export type SiteSettingsInput = {
  HideBackorders: Scalars['Boolean']['input'];
  QuickbooksGiftCardProductId: Scalars['String']['input'];
  QuickbooksProductSalesOfIncomeAccountId: Scalars['String']['input'];
  QuickbooksRefundDepositToAccountId: Scalars['String']['input'];
};

export enum Storefront {
  Mvg = 'MVG',
  Plugtrays = 'PLUGTRAYS'
}

export type UpsPackage = {
  __typename?: 'UpsPackage';
  Label: Scalars['String']['output'];
  TrackingNumber: Scalars['String']['output'];
};

export type UpsShipment = {
  __typename?: 'UpsShipment';
  AddressOverride?: Maybe<ShippingAddress>;
  Errors?: Maybe<Array<UpsShipmentError>>;
  Id: Scalars['ID']['output'];
  OrderId: Scalars['String']['output'];
  Packages?: Maybe<Array<UpsPackage>>;
  ShipmentIdentificationNumber?: Maybe<Scalars['String']['output']>;
  Status: ShipmentStatus;
  TimestampCreated: Scalars['Int']['output'];
  TotalCharges?: Maybe<Scalars['Float']['output']>;
  Type: ShipmentRequestType;
};

export type UpsShipmentError = {
  __typename?: 'UpsShipmentError';
  Code: Scalars['String']['output'];
  Message: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  ProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  address: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type UserGiftCard = {
  __typename?: 'UserGiftCard';
  Balance: Scalars['Float']['output'];
  Id: Scalars['ID']['output'];
};

export type UserInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarrantyStates = {
  __typename?: 'WarrantyStates';
  WaiverRequiredStates: Array<Scalars['String']['output']>;
  WarrantyStates: Array<Scalars['String']['output']>;
};

export type AddCartGiftCardMutationVariables = Exact<{
  GiftCard: GiftCardInput;
}>;


export type AddCartGiftCardMutation = { __typename?: 'Mutation', AddCartGiftCard?: { __typename?: 'Cart', WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, PlantType?: PlantType | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null };

export type CheckoutMutationVariables = Exact<{
  Review: Scalars['Boolean']['input'];
}>;


export type CheckoutMutation = { __typename?: 'Mutation', CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type CheckoutV1ReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutV1ReviewQuery = { __typename?: 'Query', CheckoutV1Review?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type CheckoutV1ReviewShippingFinalizedQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutV1ReviewShippingFinalizedQuery = { __typename?: 'Query', CheckoutV1Review?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type CheckoutV1ReviewWithWarrantyStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutV1ReviewWithWarrantyStatesQuery = { __typename?: 'Query', CheckoutV1Review?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null, GetWarrantyStatesV1: { __typename?: 'WarrantyStates', WarrantyStates: Array<string>, WaiverRequiredStates: Array<string> } };

export type CreateProductNotificationV1MutationVariables = Exact<{
  Id: Scalars['String']['input'];
  Email: Scalars['String']['input'];
  PlantType: PlantType;
}>;


export type CreateProductNotificationV1Mutation = { __typename?: 'Mutation', CreateProductNotificationV1?: boolean | null };

export type CoreCartFieldsV1Fragment = { __typename?: 'Cart', WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, PlantType?: PlantType | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null };

export type CoreCheckoutFieldsV1Fragment = { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null };

export type CoreOrderFieldsV1Fragment = { __typename?: 'Order', Id: string, SourceIp?: string | null, Status?: OrderStatus | null, Subtotal?: number | null, GiftCardSubtotal?: number | null, Tax?: number | null, TimestampCreated?: number | null, Total?: number | null, UserId?: string | null, InvoiceId?: number | null, WarrantyValid?: boolean | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, PricePlugtrays?: number | null, NamePlugtrays?: string | null } | null> | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, PaymentAuthorization?: { __typename?: 'PaymentAuthorization', ResponseCode?: string | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null };

export type GetCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartQuery = { __typename?: 'Query', GetCart?: { __typename?: 'Cart', WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, PlantType?: PlantType | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null };

export type GetMyOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrdersQuery = { __typename?: 'Query', GetMyOrders?: Array<{ __typename?: 'Order', Id: string, SourceIp?: string | null, Status?: OrderStatus | null, Subtotal?: number | null, Tax?: number | null, TimestampCreated?: number | null, Total?: number | null, UserId?: string | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, PricePlugtrays?: number | null, NamePlugtrays?: string | null } | null> | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, PaymentAuthorization?: { __typename?: 'PaymentAuthorization', ResponseCode?: string | null } | null } | null> | null };

export type GetOrderQueryVariables = Exact<{
  Id: Scalars['String']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', GetOrder?: { __typename?: 'Order', Id: string, SourceIp?: string | null, Status?: OrderStatus | null, Subtotal?: number | null, GiftCardSubtotal?: number | null, Tax?: number | null, TimestampCreated?: number | null, Total?: number | null, UserId?: string | null, InvoiceId?: number | null, WarrantyValid?: boolean | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, PricePlugtrays?: number | null, NamePlugtrays?: string | null } | null> | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, PaymentAuthorization?: { __typename?: 'PaymentAuthorization', ResponseCode?: string | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null } | null };

export type GetShippingOptionsQueryVariables = Exact<{
  Address: GetShippingAddressInput;
  PlugtrayCount: Scalars['Int']['input'];
  PotCount: Scalars['Int']['input'];
}>;


export type GetShippingOptionsQuery = { __typename?: 'Query', GetShippingOptions?: Array<{ __typename?: 'ShippingOption', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, PriceCurrency?: string | null, ServiceCode?: string | null, BillingWeight?: number | null } | null> | null };

export type LoginMergeIdentityMutationVariables = Exact<{
  UserId: Scalars['ID']['input'];
}>;


export type LoginMergeIdentityMutation = { __typename?: 'Mutation', LoginMergeIdentity?: boolean | null };

export type RedeemGiftCardMutationVariables = Exact<{
  Id: Scalars['String']['input'];
  Pin: Scalars['String']['input'];
}>;


export type RedeemGiftCardMutation = { __typename?: 'Mutation', RedeemGiftCard?: { __typename?: 'Cart', GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type RemoveGiftCardCheckoutMutationVariables = Exact<{
  Index: Scalars['Int']['input'];
}>;


export type RemoveGiftCardCheckoutMutation = { __typename?: 'Mutation', RemoveCartGiftCard?: { __typename?: 'Cart', GiftCards?: Array<{ __typename?: 'GiftCard', Index: number } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type RemoveGiftCardToRedeemMutationVariables = Exact<{
  Index: Scalars['Int']['input'];
}>;


export type RemoveGiftCardToRedeemMutation = { __typename?: 'Mutation', RemoveGiftCardToRedeem?: { __typename?: 'Cart', GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type SaveCartBillingOnlyMutationVariables = Exact<{
  FirstName: Scalars['String']['input'];
  LastName: Scalars['String']['input'];
  Address: Scalars['String']['input'];
  Address2?: InputMaybe<Scalars['String']['input']>;
  City: Scalars['String']['input'];
  State: Scalars['String']['input'];
  Zip: Scalars['String']['input'];
  Phone: Scalars['String']['input'];
  Email: Scalars['String']['input'];
  CreateAccountPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveCartBillingOnlyMutation = { __typename?: 'Mutation', SaveCart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type SaveCartBillingPaymentMutationVariables = Exact<{
  FirstName: Scalars['String']['input'];
  LastName: Scalars['String']['input'];
  Address: Scalars['String']['input'];
  Address2?: InputMaybe<Scalars['String']['input']>;
  City: Scalars['String']['input'];
  State: Scalars['String']['input'];
  Zip: Scalars['String']['input'];
  Phone: Scalars['String']['input'];
  Email: Scalars['String']['input'];
  Token: Scalars['String']['input'];
  CreateAccountPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveCartBillingPaymentMutation = { __typename?: 'Mutation', SaveCart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type SaveCartShippingMutationVariables = Exact<{
  DaysInTransit?: InputMaybe<Scalars['String']['input']>;
  DeliveryTime?: InputMaybe<Scalars['String']['input']>;
  Price?: InputMaybe<Scalars['Float']['input']>;
  ServiceCode?: InputMaybe<Scalars['String']['input']>;
  DeliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  IsGift?: InputMaybe<Scalars['Boolean']['input']>;
  GiftMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveCartShippingMutation = { __typename?: 'Mutation', SaveCart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, PlantType?: PlantType | null } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type SaveCartShippingAddressMutationVariables = Exact<{
  FirstName: Scalars['String']['input'];
  LastName: Scalars['String']['input'];
  Company?: InputMaybe<Scalars['String']['input']>;
  Address: Scalars['String']['input'];
  Address2?: InputMaybe<Scalars['String']['input']>;
  City: Scalars['String']['input'];
  State: Scalars['String']['input'];
  Zip: Scalars['String']['input'];
  Phone: Scalars['String']['input'];
  Email: Scalars['String']['input'];
  WaiveWarrantyPlugtrays: Scalars['Boolean']['input'];
  WaiveWarranty: Scalars['Boolean']['input'];
}>;


export type SaveCartShippingAddressMutation = { __typename?: 'Mutation', SaveCart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type SetCartProductQuantityMutationVariables = Exact<{
  Id: Scalars['String']['input'];
  Quantity: Scalars['Int']['input'];
  PlantType: PlantType;
}>;


export type SetCartProductQuantityMutation = { __typename?: 'Mutation', SaveCartProduct?: { __typename?: 'Cart', WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, PlantType?: PlantType | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null };

export type SetCartProductQuantityWithCheckoutReviewMutationVariables = Exact<{
  Id: Scalars['String']['input'];
  Quantity: Scalars['Int']['input'];
  PlantType: PlantType;
}>;


export type SetCartProductQuantityWithCheckoutReviewMutation = { __typename?: 'Mutation', SaveCartProduct?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, PlantType?: PlantType | null } | null> | null } | null, CheckoutV1?: { __typename?: 'CheckoutResult', OrderId?: string | null, Errors: Array<string>, Status: string, Total: number, Tax: number, Subtotal: number, GiftCardSubtotal: number, WarrantyValid?: boolean | null, PaymentRequired: boolean, GiftCardBalanceAvailable: number, GiftCardRedemptionsTotal: number, TotalToCharge: number, PotCount: number, PlugtrayCount: number, Storefront: Storefront, WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, MeetsMinimums: boolean, BoxSpaceRemainingPots: number, Cart?: { __typename?: 'Cart', Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, Status?: string | null, QuantityValidated?: number | null, QuantityBackorder?: number | null, CommonName?: string | null, BotanicalName?: string | null, NamePlugtrays?: string | null, Name?: string | null, PricePlugtrays?: number | null, Price?: number | null, Slug?: string | null, PlantType?: PlantType | null, LineSubtotal?: number | null, PotCount?: number | null, PlugtrayCount?: number | null, ImageHashes?: Array<string | null> | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null } | null };

export type UpdateCartGiftCardMutationVariables = Exact<{
  Index: Scalars['Int']['input'];
  GiftCard: GiftCardInput;
}>;


export type UpdateCartGiftCardMutation = { __typename?: 'Mutation', UpdateCartGiftCard?: { __typename?: 'Cart', WaiveWarranty?: boolean | null, WaiveWarrantyPlugtrays?: boolean | null, Products?: Array<{ __typename?: 'CartProduct', Id: string, Quantity: number, PlantType?: PlantType | null } | null> | null, Shipping?: { __typename?: 'ShippingAddress', FirstName?: string | null, LastName?: string | null, Address?: string | null, Address2?: string | null, City?: string | null, State?: string | null, Zip?: string | null, Phone?: string | null, Email?: string | null } | null, Billing?: { __typename?: 'BillingAddress', FirstName: string, LastName: string, Address: string, Address2?: string | null, City: string, State: string, Zip: string, Phone: string, Email: string } | null, Payment?: { __typename?: 'Payment', Token?: string | null } | null, ShippingService?: { __typename?: 'Shipping', DeliveryInstructions?: string | null, IsGift?: boolean | null, GiftMessage?: string | null, WaiveWarranty?: boolean | null, shippingService?: { __typename?: 'ShippingService', DaysInTransit?: string | null, DeliveryTime?: string | null, Price?: number | null, ServiceCode?: string | null } | null } | null, GiftCards?: Array<{ __typename?: 'GiftCard', Index: number, RecipientName: string, RecipientEmail: string, SenderName: string, Amount: number, Message?: string | null } | null> | null, GiftCardRedemptions?: Array<{ __typename?: 'GiftCardRedemption', Id: string, Balance?: number | null } | null> | null } | null };

export type ValidateAddressQueryVariables = Exact<{
  Address: AddressInput;
}>;


export type ValidateAddressQuery = { __typename?: 'Query', ValidateAddress?: Array<{ __typename?: 'Address', Address: string, Address2?: string | null, City: string, State: string, Zip: string } | null> | null };

export type ValidateAddressV1MutationVariables = Exact<{
  Address: AddressInput;
}>;


export type ValidateAddressV1Mutation = { __typename?: 'Mutation', ValidateAddressV1?: Array<{ __typename?: 'Address', Address: string, Address2?: string | null, City: string, State: string, Zip: string } | null> | null };


export const CoreCartFieldsV1FragmentDoc = `
    fragment CoreCartFieldsV1 on Cart {
  Products {
    Id
    Quantity
    PlantType
  }
  Shipping {
    FirstName
    LastName
    Address
    Address2
    City
    State
    Zip
    Phone
    Email
  }
  Billing {
    FirstName
    LastName
    Address
    Address2
    City
    State
    Zip
    Phone
    Email
  }
  Payment {
    Token
  }
  ShippingService {
    shippingService {
      DaysInTransit
      DeliveryTime
      Price
      ServiceCode
    }
    DeliveryInstructions
    IsGift
    GiftMessage
    WaiveWarranty
  }
  GiftCards {
    Index
    RecipientName
    RecipientEmail
    SenderName
    Amount
    Message
  }
  GiftCardRedemptions {
    Id
    Balance
  }
  WaiveWarranty
  WaiveWarrantyPlugtrays
}
    `;
export const CoreCheckoutFieldsV1FragmentDoc = `
    fragment CoreCheckoutFieldsV1 on CheckoutResult {
  OrderId
  Errors
  Status
  Total
  Tax
  Subtotal
  GiftCardSubtotal
  WarrantyValid
  PaymentRequired
  GiftCardBalanceAvailable
  GiftCardRedemptionsTotal
  TotalToCharge
  PotCount
  PlugtrayCount
  Cart {
    Products {
      Id
      Quantity
      Status
      QuantityValidated
      QuantityBackorder
      CommonName
      BotanicalName
      NamePlugtrays
      Name
      PricePlugtrays
      Price
      Slug
      PlantType
      LineSubtotal
      PotCount
      PlugtrayCount
      ImageHashes
    }
    Shipping {
      FirstName
      LastName
      Address
      Address2
      City
      State
      Zip
      Phone
      Email
    }
    Billing {
      FirstName
      LastName
      Address
      Address2
      City
      State
      Zip
      Phone
      Email
    }
    Payment {
      Token
    }
    ShippingService {
      shippingService {
        DaysInTransit
        DeliveryTime
        Price
        ServiceCode
      }
      DeliveryInstructions
      IsGift
      GiftMessage
      WaiveWarranty
    }
    GiftCards {
      Index
      RecipientName
      RecipientEmail
      SenderName
      Amount
      Message
    }
    GiftCardRedemptions {
      Id
      Balance
    }
  }
  Storefront
  WaiveWarranty
  WaiveWarrantyPlugtrays
  MeetsMinimums
  BoxSpaceRemainingPots
}
    `;
export const CoreOrderFieldsV1FragmentDoc = `
    fragment CoreOrderFieldsV1 on Order {
  Products {
    Id
    Quantity
    Status
    QuantityValidated
    PricePlugtrays
    NamePlugtrays
  }
  ShippingService {
    shippingService {
      DaysInTransit
      DeliveryTime
      Price
      ServiceCode
    }
    DeliveryInstructions
    IsGift
    GiftMessage
    WaiveWarranty
  }
  Shipping {
    FirstName
    LastName
    Address
    Address2
    City
    State
    Zip
    Phone
    Email
  }
  Billing {
    FirstName
    LastName
    Address
    Address2
    City
    State
    Zip
    Phone
    Email
  }
  Payment {
    Token
  }
  Id
  PaymentAuthorization {
    ResponseCode
  }
  SourceIp
  Status
  Subtotal
  GiftCardSubtotal
  Tax
  TimestampCreated
  Total
  UserId
  InvoiceId
  WarrantyValid
  GiftCards {
    Index
    RecipientName
    RecipientEmail
    SenderName
    Amount
    Message
  }
}
    `;
export const AddCartGiftCardDocument = `
    mutation addCartGiftCard($GiftCard: GiftCardInput!) {
  AddCartGiftCard(GiftCard: $GiftCard) {
    ...CoreCartFieldsV1
  }
}
    ${CoreCartFieldsV1FragmentDoc}`;

export const useAddCartGiftCardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCartGiftCardMutation, TError, AddCartGiftCardMutationVariables, TContext>) => {
    
    return useMutation<AddCartGiftCardMutation, TError, AddCartGiftCardMutationVariables, TContext>(
      ['addCartGiftCard'],
      (variables?: AddCartGiftCardMutationVariables) => fetchData<AddCartGiftCardMutation, AddCartGiftCardMutationVariables>(AddCartGiftCardDocument, variables)(),
      options
    )};

export const CheckoutDocument = `
    mutation checkout($Review: Boolean!) {
  CheckoutV1(Review: $Review, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useCheckoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CheckoutMutation, TError, CheckoutMutationVariables, TContext>) => {
    
    return useMutation<CheckoutMutation, TError, CheckoutMutationVariables, TContext>(
      ['checkout'],
      (variables?: CheckoutMutationVariables) => fetchData<CheckoutMutation, CheckoutMutationVariables>(CheckoutDocument, variables)(),
      options
    )};

export const CheckoutV1ReviewDocument = `
    query checkoutV1Review {
  CheckoutV1Review(Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useCheckoutV1ReviewQuery = <
      TData = CheckoutV1ReviewQuery,
      TError = unknown
    >(
      variables?: CheckoutV1ReviewQueryVariables,
      options?: UseQueryOptions<CheckoutV1ReviewQuery, TError, TData>
    ) => {
    
    return useQuery<CheckoutV1ReviewQuery, TError, TData>(
      variables === undefined ? ['checkoutV1Review'] : ['checkoutV1Review', variables],
      fetchData<CheckoutV1ReviewQuery, CheckoutV1ReviewQueryVariables>(CheckoutV1ReviewDocument, variables),
      options
    )};

export const useInfiniteCheckoutV1ReviewQuery = <
      TData = CheckoutV1ReviewQuery,
      TError = unknown
    >(
      variables?: CheckoutV1ReviewQueryVariables,
      options?: UseInfiniteQueryOptions<CheckoutV1ReviewQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<CheckoutV1ReviewQuery, TError, TData>(
      variables === undefined ? ['checkoutV1Review.infinite'] : ['checkoutV1Review.infinite', variables],
      (metaData) => fetchData<CheckoutV1ReviewQuery, CheckoutV1ReviewQueryVariables>(CheckoutV1ReviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CheckoutV1ReviewShippingFinalizedDocument = `
    query checkoutV1ReviewShippingFinalized {
  CheckoutV1Review(Storefront: MVG, ShippingFinalized: true) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useCheckoutV1ReviewShippingFinalizedQuery = <
      TData = CheckoutV1ReviewShippingFinalizedQuery,
      TError = unknown
    >(
      variables?: CheckoutV1ReviewShippingFinalizedQueryVariables,
      options?: UseQueryOptions<CheckoutV1ReviewShippingFinalizedQuery, TError, TData>
    ) => {
    
    return useQuery<CheckoutV1ReviewShippingFinalizedQuery, TError, TData>(
      variables === undefined ? ['checkoutV1ReviewShippingFinalized'] : ['checkoutV1ReviewShippingFinalized', variables],
      fetchData<CheckoutV1ReviewShippingFinalizedQuery, CheckoutV1ReviewShippingFinalizedQueryVariables>(CheckoutV1ReviewShippingFinalizedDocument, variables),
      options
    )};

export const useInfiniteCheckoutV1ReviewShippingFinalizedQuery = <
      TData = CheckoutV1ReviewShippingFinalizedQuery,
      TError = unknown
    >(
      variables?: CheckoutV1ReviewShippingFinalizedQueryVariables,
      options?: UseInfiniteQueryOptions<CheckoutV1ReviewShippingFinalizedQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<CheckoutV1ReviewShippingFinalizedQuery, TError, TData>(
      variables === undefined ? ['checkoutV1ReviewShippingFinalized.infinite'] : ['checkoutV1ReviewShippingFinalized.infinite', variables],
      (metaData) => fetchData<CheckoutV1ReviewShippingFinalizedQuery, CheckoutV1ReviewShippingFinalizedQueryVariables>(CheckoutV1ReviewShippingFinalizedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CheckoutV1ReviewWithWarrantyStatesDocument = `
    query checkoutV1ReviewWithWarrantyStates {
  CheckoutV1Review(Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
  GetWarrantyStatesV1 {
    WarrantyStates
    WaiverRequiredStates
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useCheckoutV1ReviewWithWarrantyStatesQuery = <
      TData = CheckoutV1ReviewWithWarrantyStatesQuery,
      TError = unknown
    >(
      variables?: CheckoutV1ReviewWithWarrantyStatesQueryVariables,
      options?: UseQueryOptions<CheckoutV1ReviewWithWarrantyStatesQuery, TError, TData>
    ) => {
    
    return useQuery<CheckoutV1ReviewWithWarrantyStatesQuery, TError, TData>(
      variables === undefined ? ['checkoutV1ReviewWithWarrantyStates'] : ['checkoutV1ReviewWithWarrantyStates', variables],
      fetchData<CheckoutV1ReviewWithWarrantyStatesQuery, CheckoutV1ReviewWithWarrantyStatesQueryVariables>(CheckoutV1ReviewWithWarrantyStatesDocument, variables),
      options
    )};

export const useInfiniteCheckoutV1ReviewWithWarrantyStatesQuery = <
      TData = CheckoutV1ReviewWithWarrantyStatesQuery,
      TError = unknown
    >(
      variables?: CheckoutV1ReviewWithWarrantyStatesQueryVariables,
      options?: UseInfiniteQueryOptions<CheckoutV1ReviewWithWarrantyStatesQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<CheckoutV1ReviewWithWarrantyStatesQuery, TError, TData>(
      variables === undefined ? ['checkoutV1ReviewWithWarrantyStates.infinite'] : ['checkoutV1ReviewWithWarrantyStates.infinite', variables],
      (metaData) => fetchData<CheckoutV1ReviewWithWarrantyStatesQuery, CheckoutV1ReviewWithWarrantyStatesQueryVariables>(CheckoutV1ReviewWithWarrantyStatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateProductNotificationV1Document = `
    mutation createProductNotificationV1($Id: String!, $Email: String!, $PlantType: PlantType!) {
  CreateProductNotificationV1(Id: $Id, Email: $Email, PlantType: $PlantType)
}
    `;

export const useCreateProductNotificationV1Mutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProductNotificationV1Mutation, TError, CreateProductNotificationV1MutationVariables, TContext>) => {
    
    return useMutation<CreateProductNotificationV1Mutation, TError, CreateProductNotificationV1MutationVariables, TContext>(
      ['createProductNotificationV1'],
      (variables?: CreateProductNotificationV1MutationVariables) => fetchData<CreateProductNotificationV1Mutation, CreateProductNotificationV1MutationVariables>(CreateProductNotificationV1Document, variables)(),
      options
    )};

export const GetCartDocument = `
    query GetCart {
  GetCart {
    ...CoreCartFieldsV1
  }
}
    ${CoreCartFieldsV1FragmentDoc}`;

export const useGetCartQuery = <
      TData = GetCartQuery,
      TError = unknown
    >(
      variables?: GetCartQueryVariables,
      options?: UseQueryOptions<GetCartQuery, TError, TData>
    ) => {
    
    return useQuery<GetCartQuery, TError, TData>(
      variables === undefined ? ['GetCart'] : ['GetCart', variables],
      fetchData<GetCartQuery, GetCartQueryVariables>(GetCartDocument, variables),
      options
    )};

export const useInfiniteGetCartQuery = <
      TData = GetCartQuery,
      TError = unknown
    >(
      variables?: GetCartQueryVariables,
      options?: UseInfiniteQueryOptions<GetCartQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<GetCartQuery, TError, TData>(
      variables === undefined ? ['GetCart.infinite'] : ['GetCart.infinite', variables],
      (metaData) => fetchData<GetCartQuery, GetCartQueryVariables>(GetCartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetMyOrdersDocument = `
    query GetMyOrders {
  GetMyOrders {
    Products {
      Id
      Quantity
      Status
      QuantityValidated
      PricePlugtrays
      NamePlugtrays
    }
    ShippingService {
      shippingService {
        DaysInTransit
        DeliveryTime
        Price
        ServiceCode
      }
      DeliveryInstructions
      IsGift
      GiftMessage
      WaiveWarranty
    }
    Shipping {
      FirstName
      LastName
      Address
      Address2
      City
      State
      Zip
      Phone
      Email
    }
    Billing {
      FirstName
      LastName
      Address
      Address2
      City
      State
      Zip
      Phone
      Email
    }
    Payment {
      Token
    }
    Id
    PaymentAuthorization {
      ResponseCode
    }
    SourceIp
    Status
    Subtotal
    Tax
    TimestampCreated
    Total
    UserId
  }
}
    `;

export const useGetMyOrdersQuery = <
      TData = GetMyOrdersQuery,
      TError = unknown
    >(
      variables?: GetMyOrdersQueryVariables,
      options?: UseQueryOptions<GetMyOrdersQuery, TError, TData>
    ) => {
    
    return useQuery<GetMyOrdersQuery, TError, TData>(
      variables === undefined ? ['GetMyOrders'] : ['GetMyOrders', variables],
      fetchData<GetMyOrdersQuery, GetMyOrdersQueryVariables>(GetMyOrdersDocument, variables),
      options
    )};

export const useInfiniteGetMyOrdersQuery = <
      TData = GetMyOrdersQuery,
      TError = unknown
    >(
      variables?: GetMyOrdersQueryVariables,
      options?: UseInfiniteQueryOptions<GetMyOrdersQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<GetMyOrdersQuery, TError, TData>(
      variables === undefined ? ['GetMyOrders.infinite'] : ['GetMyOrders.infinite', variables],
      (metaData) => fetchData<GetMyOrdersQuery, GetMyOrdersQueryVariables>(GetMyOrdersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetOrderDocument = `
    query getOrder($Id: String!) {
  GetOrder(Id: $Id) {
    ...CoreOrderFieldsV1
  }
}
    ${CoreOrderFieldsV1FragmentDoc}`;

export const useGetOrderQuery = <
      TData = GetOrderQuery,
      TError = unknown
    >(
      variables: GetOrderQueryVariables,
      options?: UseQueryOptions<GetOrderQuery, TError, TData>
    ) => {
    
    return useQuery<GetOrderQuery, TError, TData>(
      ['getOrder', variables],
      fetchData<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, variables),
      options
    )};

export const useInfiniteGetOrderQuery = <
      TData = GetOrderQuery,
      TError = unknown
    >(
      variables: GetOrderQueryVariables,
      options?: UseInfiniteQueryOptions<GetOrderQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<GetOrderQuery, TError, TData>(
      ['getOrder.infinite', variables],
      (metaData) => fetchData<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetShippingOptionsDocument = `
    query getShippingOptions($Address: GetShippingAddressInput!, $PlugtrayCount: Int!, $PotCount: Int!) {
  GetShippingOptions(
    Address: $Address
    PlugtrayCount: $PlugtrayCount
    PotCount: $PotCount
  ) {
    DaysInTransit
    DeliveryTime
    Price
    PriceCurrency
    ServiceCode
    BillingWeight
  }
}
    `;

export const useGetShippingOptionsQuery = <
      TData = GetShippingOptionsQuery,
      TError = unknown
    >(
      variables: GetShippingOptionsQueryVariables,
      options?: UseQueryOptions<GetShippingOptionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetShippingOptionsQuery, TError, TData>(
      ['getShippingOptions', variables],
      fetchData<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>(GetShippingOptionsDocument, variables),
      options
    )};

export const useInfiniteGetShippingOptionsQuery = <
      TData = GetShippingOptionsQuery,
      TError = unknown
    >(
      variables: GetShippingOptionsQueryVariables,
      options?: UseInfiniteQueryOptions<GetShippingOptionsQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<GetShippingOptionsQuery, TError, TData>(
      ['getShippingOptions.infinite', variables],
      (metaData) => fetchData<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>(GetShippingOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const LoginMergeIdentityDocument = `
    mutation loginMergeIdentity($UserId: ID!) {
  LoginMergeIdentity(UserId: $UserId)
}
    `;

export const useLoginMergeIdentityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LoginMergeIdentityMutation, TError, LoginMergeIdentityMutationVariables, TContext>) => {
    
    return useMutation<LoginMergeIdentityMutation, TError, LoginMergeIdentityMutationVariables, TContext>(
      ['loginMergeIdentity'],
      (variables?: LoginMergeIdentityMutationVariables) => fetchData<LoginMergeIdentityMutation, LoginMergeIdentityMutationVariables>(LoginMergeIdentityDocument, variables)(),
      options
    )};

export const RedeemGiftCardDocument = `
    mutation redeemGiftCard($Id: String!, $Pin: String!) {
  RedeemGiftCard(Id: $Id, Pin: $Pin) {
    GiftCardRedemptions {
      Id
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useRedeemGiftCardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RedeemGiftCardMutation, TError, RedeemGiftCardMutationVariables, TContext>) => {
    
    return useMutation<RedeemGiftCardMutation, TError, RedeemGiftCardMutationVariables, TContext>(
      ['redeemGiftCard'],
      (variables?: RedeemGiftCardMutationVariables) => fetchData<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>(RedeemGiftCardDocument, variables)(),
      options
    )};

export const RemoveGiftCardCheckoutDocument = `
    mutation removeGiftCardCheckout($Index: Int!) {
  RemoveCartGiftCard(Index: $Index) {
    GiftCards {
      Index
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useRemoveGiftCardCheckoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveGiftCardCheckoutMutation, TError, RemoveGiftCardCheckoutMutationVariables, TContext>) => {
    
    return useMutation<RemoveGiftCardCheckoutMutation, TError, RemoveGiftCardCheckoutMutationVariables, TContext>(
      ['removeGiftCardCheckout'],
      (variables?: RemoveGiftCardCheckoutMutationVariables) => fetchData<RemoveGiftCardCheckoutMutation, RemoveGiftCardCheckoutMutationVariables>(RemoveGiftCardCheckoutDocument, variables)(),
      options
    )};

export const RemoveGiftCardToRedeemDocument = `
    mutation removeGiftCardToRedeem($Index: Int!) {
  RemoveGiftCardToRedeem(Index: $Index) {
    GiftCardRedemptions {
      Id
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useRemoveGiftCardToRedeemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveGiftCardToRedeemMutation, TError, RemoveGiftCardToRedeemMutationVariables, TContext>) => {
    
    return useMutation<RemoveGiftCardToRedeemMutation, TError, RemoveGiftCardToRedeemMutationVariables, TContext>(
      ['removeGiftCardToRedeem'],
      (variables?: RemoveGiftCardToRedeemMutationVariables) => fetchData<RemoveGiftCardToRedeemMutation, RemoveGiftCardToRedeemMutationVariables>(RemoveGiftCardToRedeemDocument, variables)(),
      options
    )};

export const SaveCartBillingOnlyDocument = `
    mutation saveCartBillingOnly($FirstName: String!, $LastName: String!, $Address: String!, $Address2: String, $City: String!, $State: String!, $Zip: String!, $Phone: String!, $Email: String!, $CreateAccountPassword: String) {
  SaveCart(
    Billing: {FirstName: $FirstName, LastName: $LastName, Address: $Address, Address2: $Address2, City: $City, State: $State, Zip: $Zip, Phone: $Phone, Email: $Email}
    CreateAccount: {Password: $CreateAccountPassword}
  ) {
    Products {
      Id
      Quantity
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useSaveCartBillingOnlyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveCartBillingOnlyMutation, TError, SaveCartBillingOnlyMutationVariables, TContext>) => {
    
    return useMutation<SaveCartBillingOnlyMutation, TError, SaveCartBillingOnlyMutationVariables, TContext>(
      ['saveCartBillingOnly'],
      (variables?: SaveCartBillingOnlyMutationVariables) => fetchData<SaveCartBillingOnlyMutation, SaveCartBillingOnlyMutationVariables>(SaveCartBillingOnlyDocument, variables)(),
      options
    )};

export const SaveCartBillingPaymentDocument = `
    mutation saveCartBillingPayment($FirstName: String!, $LastName: String!, $Address: String!, $Address2: String, $City: String!, $State: String!, $Zip: String!, $Phone: String!, $Email: String!, $Token: String!, $CreateAccountPassword: String) {
  SaveCart(
    Billing: {FirstName: $FirstName, LastName: $LastName, Address: $Address, Address2: $Address2, City: $City, State: $State, Zip: $Zip, Phone: $Phone, Email: $Email}
    Payment: {Token: $Token}
    CreateAccount: {Password: $CreateAccountPassword}
  ) {
    Products {
      Id
      Quantity
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useSaveCartBillingPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveCartBillingPaymentMutation, TError, SaveCartBillingPaymentMutationVariables, TContext>) => {
    
    return useMutation<SaveCartBillingPaymentMutation, TError, SaveCartBillingPaymentMutationVariables, TContext>(
      ['saveCartBillingPayment'],
      (variables?: SaveCartBillingPaymentMutationVariables) => fetchData<SaveCartBillingPaymentMutation, SaveCartBillingPaymentMutationVariables>(SaveCartBillingPaymentDocument, variables)(),
      options
    )};

export const SaveCartShippingDocument = `
    mutation saveCartShipping($DaysInTransit: String, $DeliveryTime: String, $Price: Float, $ServiceCode: String, $DeliveryInstructions: String, $IsGift: Boolean, $GiftMessage: String) {
  SaveCart(
    ShippingService: {shippingService: {DaysInTransit: $DaysInTransit, DeliveryTime: $DeliveryTime, Price: $Price, ServiceCode: $ServiceCode}, DeliveryInstructions: $DeliveryInstructions, IsGift: $IsGift, GiftMessage: $GiftMessage}
  ) {
    Products {
      Id
      Quantity
      PlantType
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useSaveCartShippingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveCartShippingMutation, TError, SaveCartShippingMutationVariables, TContext>) => {
    
    return useMutation<SaveCartShippingMutation, TError, SaveCartShippingMutationVariables, TContext>(
      ['saveCartShipping'],
      (variables?: SaveCartShippingMutationVariables) => fetchData<SaveCartShippingMutation, SaveCartShippingMutationVariables>(SaveCartShippingDocument, variables)(),
      options
    )};

export const SaveCartShippingAddressDocument = `
    mutation saveCartShippingAddress($FirstName: String!, $LastName: String!, $Company: String, $Address: String!, $Address2: String, $City: String!, $State: String!, $Zip: String!, $Phone: String!, $Email: String!, $WaiveWarrantyPlugtrays: Boolean!, $WaiveWarranty: Boolean!) {
  SaveCart(
    Shipping: {FirstName: $FirstName, LastName: $LastName, Company: $Company, Address: $Address, Address2: $Address2, City: $City, State: $State, Zip: $Zip, Phone: $Phone, Email: $Email}
    WaiveWarrantyPlugtrays: $WaiveWarrantyPlugtrays
    WaiveWarranty: $WaiveWarranty
  ) {
    Products {
      Id
      Quantity
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useSaveCartShippingAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveCartShippingAddressMutation, TError, SaveCartShippingAddressMutationVariables, TContext>) => {
    
    return useMutation<SaveCartShippingAddressMutation, TError, SaveCartShippingAddressMutationVariables, TContext>(
      ['saveCartShippingAddress'],
      (variables?: SaveCartShippingAddressMutationVariables) => fetchData<SaveCartShippingAddressMutation, SaveCartShippingAddressMutationVariables>(SaveCartShippingAddressDocument, variables)(),
      options
    )};

export const SetCartProductQuantityDocument = `
    mutation setCartProductQuantity($Id: String!, $Quantity: Int!, $PlantType: PlantType!) {
  SaveCartProduct(Id: $Id, Quantity: $Quantity, PlantType: $PlantType) {
    ...CoreCartFieldsV1
  }
}
    ${CoreCartFieldsV1FragmentDoc}`;

export const useSetCartProductQuantityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetCartProductQuantityMutation, TError, SetCartProductQuantityMutationVariables, TContext>) => {
    
    return useMutation<SetCartProductQuantityMutation, TError, SetCartProductQuantityMutationVariables, TContext>(
      ['setCartProductQuantity'],
      (variables?: SetCartProductQuantityMutationVariables) => fetchData<SetCartProductQuantityMutation, SetCartProductQuantityMutationVariables>(SetCartProductQuantityDocument, variables)(),
      options
    )};

export const SetCartProductQuantityWithCheckoutReviewDocument = `
    mutation setCartProductQuantityWithCheckoutReview($Id: String!, $Quantity: Int!, $PlantType: PlantType!) {
  SaveCartProduct(Id: $Id, Quantity: $Quantity, PlantType: $PlantType) {
    Products {
      Id
      Quantity
      PlantType
    }
  }
  CheckoutV1(Review: true, Storefront: MVG) {
    ...CoreCheckoutFieldsV1
  }
}
    ${CoreCheckoutFieldsV1FragmentDoc}`;

export const useSetCartProductQuantityWithCheckoutReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetCartProductQuantityWithCheckoutReviewMutation, TError, SetCartProductQuantityWithCheckoutReviewMutationVariables, TContext>) => {
    
    return useMutation<SetCartProductQuantityWithCheckoutReviewMutation, TError, SetCartProductQuantityWithCheckoutReviewMutationVariables, TContext>(
      ['setCartProductQuantityWithCheckoutReview'],
      (variables?: SetCartProductQuantityWithCheckoutReviewMutationVariables) => fetchData<SetCartProductQuantityWithCheckoutReviewMutation, SetCartProductQuantityWithCheckoutReviewMutationVariables>(SetCartProductQuantityWithCheckoutReviewDocument, variables)(),
      options
    )};

export const UpdateCartGiftCardDocument = `
    mutation updateCartGiftCard($Index: Int!, $GiftCard: GiftCardInput!) {
  UpdateCartGiftCard(Index: $Index, GiftCard: $GiftCard) {
    ...CoreCartFieldsV1
  }
}
    ${CoreCartFieldsV1FragmentDoc}`;

export const useUpdateCartGiftCardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCartGiftCardMutation, TError, UpdateCartGiftCardMutationVariables, TContext>) => {
    
    return useMutation<UpdateCartGiftCardMutation, TError, UpdateCartGiftCardMutationVariables, TContext>(
      ['updateCartGiftCard'],
      (variables?: UpdateCartGiftCardMutationVariables) => fetchData<UpdateCartGiftCardMutation, UpdateCartGiftCardMutationVariables>(UpdateCartGiftCardDocument, variables)(),
      options
    )};

export const ValidateAddressDocument = `
    query validateAddress($Address: AddressInput!) {
  ValidateAddress(Address: $Address) {
    Address
    Address2
    City
    State
    Zip
  }
}
    `;

export const useValidateAddressQuery = <
      TData = ValidateAddressQuery,
      TError = unknown
    >(
      variables: ValidateAddressQueryVariables,
      options?: UseQueryOptions<ValidateAddressQuery, TError, TData>
    ) => {
    
    return useQuery<ValidateAddressQuery, TError, TData>(
      ['validateAddress', variables],
      fetchData<ValidateAddressQuery, ValidateAddressQueryVariables>(ValidateAddressDocument, variables),
      options
    )};

export const useInfiniteValidateAddressQuery = <
      TData = ValidateAddressQuery,
      TError = unknown
    >(
      variables: ValidateAddressQueryVariables,
      options?: UseInfiniteQueryOptions<ValidateAddressQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<ValidateAddressQuery, TError, TData>(
      ['validateAddress.infinite', variables],
      (metaData) => fetchData<ValidateAddressQuery, ValidateAddressQueryVariables>(ValidateAddressDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ValidateAddressV1Document = `
    mutation ValidateAddressV1($Address: AddressInput!) {
  ValidateAddressV1(Address: $Address) {
    Address
    Address2
    City
    State
    Zip
  }
}
    `;

export const useValidateAddressV1Mutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateAddressV1Mutation, TError, ValidateAddressV1MutationVariables, TContext>) => {
    
    return useMutation<ValidateAddressV1Mutation, TError, ValidateAddressV1MutationVariables, TContext>(
      ['ValidateAddressV1'],
      (variables?: ValidateAddressV1MutationVariables) => fetchData<ValidateAddressV1Mutation, ValidateAddressV1MutationVariables>(ValidateAddressV1Document, variables)(),
      options
    )};
